<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">{{ $t('invoice.dueDate') }}</label>
<!--                <datepicker class="w-full" :highlighted="highlighted"-->
<!--                            :language="vi" :format="'dd/MM/yyyy'" v-model="dueDate"-->
<!--                            data-vv-validate-on="input" name="dueDate">-->
<!--                </datepicker>-->
                <date-range-picker
                    ref="picker" class="w-full"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'right'"
                    @update="dateRangePickerDue"
                    v-model="dateRangeDue">
                </date-range-picker>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-2">
                <label class="vs-input--label">{{ $t('invoice.paymentDate') }}</label>
<!--                <datepicker class="w-full" :highlighted="highlighted" :disabledDates="disabledFn"-->
<!--                            :language="vi" :format="'dd/MM/yyyy'" v-model="paymentDate"-->
<!--                            data-vv-validate-on="input" name="paymentDate">-->
<!--                </datepicker>-->
                <date-range-picker
                    ref="picker" class="w-full"
                    :locale-data="{format: 'dd/mm/yyyy' }"
                    :opens="'right'"
                    @update="dateRangePickerPayment"
                    v-model="dateRangePayment">
                </date-range-picker>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mt-0 mt-2">
                <label class="vs-input--label required">{{ $t('invoice.status') }}</label>
                <v-select class="w-full" v-model="selectedStatus" :options="statusOptions"
                          :reduce="(option) => option.value"
                          name="status">
                </v-select>
            </div>
<!--            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full lg:mt-0 mt-2">-->
<!--                <label class="vs-input&#45;&#45;label">Tìm kiếm</label>-->
<!--                <vs-input class="w-full" v-model="keySearch" placeholder="Tìm kiếm theo tên danh mục ..."></vs-input>-->
<!--            </div>-->
            <div class="vx-col w-full flex">
                <vs-button class="mt-6" icon-pack="feather" icon="icon-search" @click="filter">{{ $t('onMap.search') }}</vs-button>
                <vs-button class="mt-6 ml-auto" icon-pack="feather" icon="icon-plus" @click="addReceipts" type="border">
                    {{ $t('button.add') }}
                </vs-button>
            </div>
        </div>

        <!-- AgGrid Table -->
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="receiptsData"
                     :animateRows="true"
                     paginationPageSize="20"
                     :pagination="true"
                     @pagination-changed="onPaginationChanged"
                     @grid-ready="onGridReady"
                     :localeText="{noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                     :autoSizeStrategy="autoSizeStrategy"
                     tooltipShowDelay="0"
                     tooltipHideDelay="5000"
                     :tooltipMouseTrack="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="receiptsData && receiptsData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">{{ $t('dashboard.NumberOfElementsPage') }}</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                                <span class="mr-2">
                                    {{
                                        receiptsData.length - currentPage * pageSize > 0 ? currentPage *
                                            pageSize
                                            : receiptsData.length
                                    }} /
                                    {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @input="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import moment from "moment"
import Datepicker from "vuejs-datepicker"
import {vi} from 'vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import DateRangePicker from '../../../components/vue2-daterange-picker/components/DateRangePicker.vue'
import CellRendererActions from "./cell-renderer/CellRendererActions"
import CellRendererStatus from "./cell-renderer/CellRendererStatus"
import CellRendererType from "./cell-renderer/CellRendererType"

export default {
    name: "ReceiptsManage",
    components: {
        AgGridVue,
        Datepicker,
        vSelect,
        DateRangePicker,
        CellRendererActions,
        CellRendererStatus,
        CellRendererType,
    },

    data() {
        return {
            gridApi: null,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('invoice.index'),
                    field: 'stt',
                    minWidth: 100,
                },
                {
                    headerName: this.$t('invoice.billCode'),
                    field: 'billCode',
                    minWidth: 150
                },
                {
                    headerName: this.$t('invoice.paymentDate'),
                    field: 'paymentDateStr',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('invoice.dueDate'),
                    field: 'dueDateStr',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('invoice.type'),
                    field: 'type',
                    width: 200,
                    cellRenderer: 'CellRendererType',
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('invoice.paid'),
                    field: 'paidFormat',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('invoice.amount'),
                    field: 'amountFormat',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('invoice.status'),
                    field: 'status',
                    width: 200,
                    cellRenderer: 'CellRendererStatus',
                    suppressSizeToFit: true,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDateStr',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('menuOrganization.modifiedDate'),
                    field: 'modifiedDateStr',
                    minWidth: 150,
                },
                {
                    headerName: this.$t('invoice.actions'),
                    field: 'actions',
                    minWidth: 150,
                    cellRenderer: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],

            pageNumber: 0,
            pageSize: 30,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
            keySearch: null,
            receiptsData: [],
            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            statusOptions: [
                {value: null, label: this.$t('invoice.all')},
                {value: 0, label: this.$t('invoice.haventPaidYet')},
                {value: 1, label: this.$t('invoice.paid')},
                {value: 2, label: this.$t('invoice.paying')},
            ],
            selectedStatus: null,
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isAfter(moment(), 'days')) {
                        return true;
                    }
                }
            },

            dateRangeDue: {
                endDate: null,
                startDate: null
            },
            dateRangePayment: {
                endDate: null,
                startDate: null
            },
        }
    },

    watch: {
        '$store.state.isUpdateReceipts'(val) {
            if (val) {
                this.filter();
                this.$store.commit('UPDATE_RECEIPTS', false);
            }
        }
    },

    created() {
        this.getReceipts();
    },

    methods: {
        addReceipts() {
            this.$router.push('/user/details-receipts').catch(() => {
            },)
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getReceipts();
        },

        onGridReady(params) {
            this.gridApi = params.api;
        },

        onPaginationChanged() {
            if (this.gridApi) {
                this.totalPages = this.gridApi.paginationGetTotalPages();
            }
        },

        loadPage: function (currentPage) {
            this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
            this.getReceipts();
        },

        changePageSize(number) {
            this.pageSize = number;
            this.filter();
        },

        getReceipts() {
            let payload = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                startDueDate: this.dateRangeDue.startDate,
                endDueDate: this.dateRangeDue.endDate,
                startPaymentDate: this.dateRangePayment.startDate,
                endPaymentDate: this.dateRangePayment.endDate,
                status: this.selectedStatus,
            }

            this.$vs.loading();
            this.$crm.post('/tuition-bill/find-by-condition', payload).then(res => {
                this.$vs.loading.close();
                if (res.data.content && res.data.content.length > 0) {
                    this.receiptsData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.paidFormat = el.paid.toLocaleString();
                        el.amountFormat = el.amount.toLocaleString();
                        el.createdDateStr = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY') : null;
                        el.modifiedDateStr = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY') : null;
                        if (el.paymentDate) el.paymentDateStr = moment(el.paymentDate).format('DD/MM/YYYY');
                        if (el.dueDate) el.dueDateStr = moment(el.dueDate).format('DD/MM/YYYY');
                        return el;
                    })
                } else {
                    this.receiptsData = [];
                }
                this.totalElements = res.data.totalElements;
                this.totalPages = res.data.totalPages;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        dateRangePickerDue() {
            this.dateRangeDue.startDate = new Date(this.dateRangeDue.startDate.setHours(0, 0, 0));
            this.dateRangeDue.endDate = new Date(this.dateRangeDue.endDate.setHours(23, 59, 59));
        },

        dateRangePickerPayment() {
            this.dateRangePayment.startDate = new Date(this.dateRangePayment.startDate.setHours(0, 0, 0));
            this.dateRangePayment.endDate = new Date(this.dateRangePayment.endDate.setHours(23, 59, 59));
        },
    }
}
</script>

<style scoped>

</style>

<style lang="scss">
.ag-paging-panel {
    display: none;
}
</style>
